import { render } from "./ProductGroups.vue?vue&type=template&id=5e0b4ed0&scoped=true"
import script from "./ProductGroups.vue?vue&type=script&lang=js"
export * from "./ProductGroups.vue?vue&type=script&lang=js"

import "./ProductGroups.vue?vue&type=style&index=0&id=5e0b4ed0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0b4ed0"]])

export default __exports__